export const filterOptions = (options: string[], inputValue: string) => {
  if (!inputValue) {
    return options;
  }

  return options.filter((option) =>
    option.toLowerCase().includes(inputValue.toLowerCase())
  );
};

export const filterUsedOptions = (options: string[], usedOptions: string[]) => {
  return options.filter((option) => !usedOptions.includes(option));
};

export const findCaseInsensitiveMatch = (list: string[], value: string) => {
  return list.find((option) => option.toLowerCase() === value.toLowerCase());
};

export const isValueFromList = (list: string[], value: string) => {
  return list
    .map((option) => option.toLowerCase())
    .includes(value.toLowerCase());
};
